;(function () {
    'use strict';
    if (!customElements.get('testimonials-component')) {
        class TestimonialsComponent extends HTMLElement {
            constructor() {
                super();
                this.slider = this.querySelector('.swiper.testimonials-slider');
                this.slides = Array.from(this.querySelectorAll('.swiper-slide'));
                this.swiper = null;
                this._resizeTimer = null;
                // Bind once so the same reference can be removed if needed
                this._onResize = this._handleResize.bind(this);
            }

            connectedCallback() {
                this.initSwiper();
                window.addEventListener('resize', this._onResize);
            }

            disconnectedCallback() {
                window.removeEventListener('resize', this._onResize);
                this._destroySwiper();
            }

            _handleResize() {
                // Debounce to avoid rapid re-inits while the user is resizing
                clearTimeout(this._resizeTimer);
                this._resizeTimer = setTimeout(() => this.initSwiper(), 250);
            }

            _destroySwiper() {
                if (this.swiper) {
                    this.swiper.destroy(true, true);
                    this.swiper = null;
                }
            }

            initSwiper() {
                if (!this.slider) return;

                // Always destroy before re-initializing
                this._destroySwiper();

                let slidesPerView = parseFloat(this.dataset.slidesPerView) || 3;
                slidesPerView = this.slides.length < slidesPerView
                    ? this.slides.length
                    : slidesPerView;

                this.swiper = new Swiper(this.slider, {
                    loop: true,
                    speed: 400,
                    slidesPerView: 1,
                    centeredSlides: true,
                    spaceBetween: 15,
                    pagination: {
                        el: this.querySelector('.swiper-pagination'),
                        type: 'bullets',
                        clickable: true,
                    },
                    breakpoints: {
                        750: {
                            slidesPerView: 1.5,
                            spaceBetween: 30,
                        },
                        1200: {
                            slidesPerView,
                            spaceBetween: 70,
                        },
                    },
                });
            }
        }

        customElements.define('testimonials-component', TestimonialsComponent);
    }
})();